// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4410) return "static/css/4410.f9c7a48fbd45eda3cfa1.css";
	if (chunkId === 7564) return "static/css/sender.d2fa50e600c8902170ab.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1412":"4f767f2564a62b1968c8","6877":"201f07b8e64160d7069f","9960":"5fe90e3c35a61e8ac86e"}[chunkId] + ".chunk.css";
};